import React from 'react';
import PropTypes from 'prop-types';

export const Phones = ({phones, maxItems, classStyles}) => phones.slice(0, maxItems).map(phone => (
  <span
    key={phone}
    className={classStyles}
  >
    {phone}
  </span>
));

Phones.defaultProps = {
  maxItems: 3,
  classStyles: ''
};

Phones.propTypes = {
  phones: PropTypes.arrayOf(PropTypes.string).isRequired,
  maxItems: PropTypes.number,
  classStyles: PropTypes.string
};
